import type { ExportConfig } from './types';

// A CSV export of every row a paged endpoint matches, not only the loaded page: `fetchPage`
// (numbered from 1) runs one page after another until the total count is reached or a page comes
// back empty, and `toRows` turns what it fetched into the exported rows.
export const pagedCsvExport = <Row>(
  filename: string,
  fetchPage: (
    page: number,
    pageSize: number,
    signal?: AbortSignal
  ) => Promise<{ results: Row[]; totalCount: number }>,
  pageSize: number,
  toRows: (rows: Row[]) => unknown[] = (rows) => rows
): ExportConfig => ({
  exportPresets: [
    {
      name: 'CSV',
      format: 'csv',
      filename,
      fetchRows: async (signal) => {
        const rows: Row[] = [];
        for (let page = 1; ; page += 1) {
          // Pages come one after another.
          const result = await fetchPage(page, pageSize, signal);
          rows.push(...result.results);
          if (rows.length >= result.totalCount || !result.results.length) break;
        }
        return toRows(rows);
      },
    },
  ],
});
